import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FilterModel } from 'app/core/models/admin/filter.models';

@Injectable({
  providedIn: 'root',
})
export class DashboardStockService {
  private _host: string;
  private readonly STOCK_DASHBOARD_ENDPOINT: string =
    '/api/v1/product_stock/dashboard';
  private stockDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  public stockData$: Observable<any> = this.stockDataSubject.asObservable();

  constructor(private _httpClient: HttpClient) {
    this._host = environment.operHost;
  }

  public get host(): string {
    return this._host;
  }

  /*async getDashboardData(filters: FilterModel[] = undefined): Promise<any> {
    
    let filter = '';
    if (filters) {
      filters.map(f => {
        filter += (filter !== '' ? '&' : '?') + `${f.field}=${f.filter}`;
      });
    }

    const response = await this._httpClient
      .get(this.host + this.STOCK_DASHBOARD_ENDPOINT + filter)
      .toPromise();

    return response;
  }*/

  async getDashboardData(filters: FilterModel[] = undefined): Promise<any> {
    let filter = '';

    if (filters) {
      filters.forEach(f => {
        // Substitui apenas no envio para o backend
        const fieldName = f.field === 'territory_id' ? 'regional_id' : f.field;
        filter += (filter !== '' ? '&' : '?') + `${fieldName}=${f.filter}`;
      });
    }

    const response = await this._httpClient
      .get(this.host + this.STOCK_DASHBOARD_ENDPOINT + filter)
      .toPromise();

    return response;
  }

  public updateStockData(data: any): void {
    this.stockDataSubject.next(data);
  }
}
